import { createAction } from 'redux-actions';
export var findPastedDeviation = createAction("DEVIATION_PASTE.FIND_DEVIATION", function (_a) {
    var deviationLookup = _a.deviationLookup, setEntityData = _a.setEntityData;
    return ({ deviationLookup: deviationLookup, setEntityData: setEntityData });
});
//# sourceMappingURL=actionCreators.js.map